import type { BrowseMarket } from '@/api/cmApi'

export const FANCY_LIMIT_TIERS = ['Minor', 'Minor1', 'Medium', 'Medium1', 'Major', 'Major1'] as const

export type FancyLimitTier = (typeof FANCY_LIMIT_TIERS)[number]

export function isFancyMarket(m: BrowseMarket): boolean {
  if (m.hasLineSession || m.isCustomFancy) return true
  const v = String(m.vendor || '').toLowerCase()
  if (v === 'custom-session') return true
  return /fancy|session/i.test(String(m.marketType || m.name || ''))
}

/** Betfair Line Session: Max bet / Max market only — no fancy Minor/Major tier. */
export function showsFancyLimitsTier(m: BrowseMarket): boolean {
  if (m.hasLineSession) return false
  return isFancyMarket(m)
}

export function defaultMaxLimitsType(raw: string | null | undefined): FancyLimitTier | string {
  const t = String(raw || 'Minor').trim()
  return (FANCY_LIMIT_TIERS as readonly string[]).includes(t) ? t : 'Minor'
}

/** Body fragment CM posts on market limits save. */
export function fancyLimitsPayload(
  m: BrowseMarket,
  maxLimitsType: string,
): { maxLimitsType: string } | Record<string, never> {
  if (!showsFancyLimitsTier(m)) return {}
  return { maxLimitsType: defaultMaxLimitsType(maxLimitsType) }
}
